import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

class ConfirmModal extends React.Component {

  static propTypes = {
    callback: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    confirmButtonProps: PropTypes.object,
    rejectButtonProps: PropTypes.object,
    confirmButtonText: PropTypes.string,
    rejectButtonText: PropTypes.string,
    reversedButtonOrder: PropTypes.bool

  };

  constructor (props) {
    super(props);

    this.state = {
      open: true,
      confirmButtonProps: props.confirmButtonProps || {className: 'btn px-30'},
      rejectButtonProps: props.rejectButtonProps || {className: 'btn px-30 outlined blue'},
      confirmButtonText: props.confirmButtonText || proxyCounterpart('YES'),
      rejectButtonText: props.rejectButtonText || proxyCounterpart('NO'),
      reversedButtonOrder: props.reversedButtonOrder || false
    };
  }

  componentWillMount = () => {
    this.disableScroll();
  }

  componentWillUnmount = () => {
    this.enableScroll();
  }

  preventDefault = (e) => {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  }

  disableScroll = () => {
    window.onwheel = this.preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
    window.ontouchmove = this.preventDefault; // mobile
  }

  enableScroll = () => {
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }

  confirm = () => {
    this.props.callback(true);
  }

  reject = () => {
    this.props.callback(false);
  }

  renderButtons = () => {
    let buttons = [
      <button key='reject' onClick={this.reject} {...this.state.rejectButtonProps}>
        {this.state.rejectButtonText}
      </button>,
      <button key='confirm' onClick={this.confirm} {...this.state.confirmButtonProps}>
        {this.state.confirmButtonText}
      </button>
    ];

    if (this.state.reversedButtonOrder) {
      buttons.reverse();
    }

    return (
      <div className="btn-wrapper">
        {buttons}
      </div>
    );
  }

  render = () => {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.reject}>
        <div className='modal-content confirm-modal'>
          <button className='close' onClick={this.reject}></button>
          <p dangerouslySetInnerHTML={{__html: this.props.message}}/>
          {this.renderButtons()}
        </div>
      </Modal>
    );
  }
}

export default ConfirmModal;



/** WEBPACK FOOTER **
 ** ./src/components/confirm-modal/confirm-modal.js
 **/